import type { App } from 'vue'
import AppImageCropper from './app-image-cropper.vue'
import AppImageInput from './app-image-input.vue'

export default {
  install (app: App) {
    app.component('AppImageInput', AppImageInput)
    app.component('AppImageCropper', AppImageCropper)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppImageInput: typeof AppImageInput,
    AppImageCropper: typeof AppImageCropper,
  }
}
